<template>
  <div class="items-list">
      <div class="il-header">

        <div class="title">{{ title }}</div>

        <div class="search">
          <TextInput
            class="search-input"
            placeholder="Type to search"
            @input="text => onSearch(text)"
          />
        </div>

        <div class="controls">
          <div>
            <input
              type="checkbox"
              class="checkbox-all"
              v-model="isAllSelected"
              :id="selectAllId"
              @change="onSelectAll">
            <label :for="selectAllId">{{ selectAllLabel }}</label>
          </div>

          <div class="header-counters">
            <span class="counter-total">{{ getTotalItemsCount() }}</span> |
            <span class="counter-selected">{{ getSelectedItemsCount() }}</span> selected
          </div>
        </div>
      </div>

      <div class="list">
        <template v-for="listItem in innerListItems">
          <div v-show="listItem.isDisplayed" class="item">
            <input
              type="checkbox"
              v-model="selectedItems"
              :id="listItem.key"
              :value="listItem"
              @change="event => changeItemSelection(listItem, event.target.checked)">
            <label :for="listItem.key">{{ listItem.label }}</label>
          </div>
        </template>
        <p v-if="!isDisplayedItemsPresent">The list is empty.</p>
      </div>
    </div>
</template>

<script>
import TextInput  from '@/components/TextInput.vue';

export default {
  components: {
    TextInput
  },
  props: {
    listItems: {
      // Item interface:
      // label: string
      // key: string | number
      // item: object
      // isDisplayed: boolean
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    selectAllLabel:  {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      innerListItems: [],
      selectedItems: [],
      isAllSelected: false
    }
  },
  watch: {
    listItems: function (newItems) {
      this.innerListItems = newItems;
      this.selectedItems = [];
    }
  },
  computed: {
    isDisplayedItemsPresent() {
      return this.innerListItems.filter(item => item.isDisplayed).length > 0;
    },
    selectAllId() {
      return crypto.randomUUID();
    }
  },
  methods: {
    addItems(items) {
      this.innerListItems = this.innerListItems.concat(items);
    },
    removeItems(items) {
      const keys = items.map(item => item.key);
      this.innerListItems = this.innerListItems?.filter(listItem => !keys.includes(listItem.key)) ?? [];
      this.selectedItems = this.selectedItems?.filter(listItem => !keys.includes(listItem.key)) ?? [];

      this.isAllSelected = this.selectedItems.length > 0;
    },
    getSelectedItems() {
      return this.selectedItems;
    },
    onSearch(searchingText) {
      this.innerListItems = this.innerListItems.map(listItem => {
        const isDisplayed = listItem.label.toLowerCase().includes(searchingText.toLowerCase());
        return { ...listItem, isDisplayed: isDisplayed };
      });
    },
    onSelectAll() {
      if (this.isAllSelected) {
        this.selectedItems = this.innerListItems;
        this.$emit('selectItems', this.innerListItems);
      } else {
        this.selectedItems = [];
        this.$emit('unselectAllItems');
      }
    },
    changeItemSelection(listItem, isChecked) {
      this.isAllSelected = false;

      isChecked
        ? this.$emit('selectItem', listItem)
        : this.$emit('unselectItem', listItem);
    },
    getTotalItemsCount() {
      return this.innerListItems.filter(prod => prod.isDisplayed).length;
    },
    getSelectedItemsCount() {
      return this.selectedItems.length;
    },
    clear() {
      this.innerListItems = [];
      this.selectedItems = [];
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';
@import '../assets/common.less';

.items-list {
  width: 100%;
  max-width: 20 * @space-xxl;
  min-width: 10 * @space-xxl;
  position: relative;
  background-color: @gray-14;
  border: 1px solid @gray-53;
  overflow: scroll;

  .list {
    overflow: visible;
  }
}
.il-header {
  padding: @space-large @space-large 0 @space-large;
}
.title {
  margin-bottom: @space-large;
  font-weight: 400;
  font-size: @font-size-lg;
  line-height: 1.5em;
}

@media screen and (min-width: 3000px) {
    .title {
      font-size: 0.55rem;
      margin-bottom: @space-small;
    }

    .search {
      margin-bottom: @space-small !important;

      ::after {
        margin-top: -0.3 * @space-base !important;
      }
    }

    .controls {
      display: block !important;
      margin-bottom: @space-small !important;
      padding-bottom: @space-small !important;

      .header-counters {
        margin-left: 0.7rem;
      }
    }
}
.search {
  position: relative;
  margin-bottom: @space-large;

  ::after {
    content: "\e98e";
    font-family: "Ericsson Icons";
    position: absolute;
    top: 50%;
    right: @space-base;
    margin-top: -0.6 * @space-base;
  }
}
.search-input {
  ::v-deep input {
    margin-right: 0;
  }
}
.controls {
  border-bottom: 1px solid @gray-53;
  padding-bottom: @space-large;
  margin-bottom: @space-large;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list {
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 14 * @space-xxl;
  padding: 2px @space-large @space-large @space-large;
  position: relative;

  .item:not(:last-child) {
    margin-bottom: 2px;
  }
}
</style>